import type { Transition } from 'motion/react';

/** Primary sidebar width — ease (no spring overshoot). */
export const SIDEBAR_TRANSITION: Transition = {
  duration: 0.52,
  ease: [0.32, 0.72, 0, 1],
};

/** Submenu accordion height. */
export const SUBMENU_TRANSITION: Transition = {
  duration: 0.4,
  ease: [0.4, 0, 0.2, 1],
};

/** Label / chevron opacity during sidebar collapse. */
export const LABEL_FADE: Transition = {
  duration: 0.28,
  ease: 'easeOut',
};

/** Stagger label fade slightly after sidebar begins expanding. */
export const LABEL_FADE_EXPAND_DELAY = 0.14;

export const SIDEBAR_WIDTH_EXPANDED = 268;
export const SIDEBAR_WIDTH_COLLAPSED = 72;

/** Fixed icon column — keeps icons anchored while labels clip. */
export const SIDEBAR_ICON_SLOT_CLASS = 'flex h-8 w-10 shrink-0 items-center justify-center';
